import { render, staticRenderFns } from "./jsaImpr.vue?vue&type=template&id=437f490a"
import script from "./jsaImpr.vue?vue&type=script&lang=js"
export * from "./jsaImpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('437f490a')) {
      api.createRecord('437f490a', component.options)
    } else {
      api.reload('437f490a', component.options)
    }
    module.hot.accept("./jsaImpr.vue?vue&type=template&id=437f490a", function () {
      api.rerender('437f490a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/jsa/risk/jsaImpr.vue"
export default component.exports